var cell_default = {
  "cell": "D-m9D",
  "header": "fNLMy",
  "selected": "ldsjp",
  "editing": "Cn6vV",
  "singleSelection": "fno6b",
  "hideLastBlock": "_5q0GW",
  "editorWrapper": "B8dN8",
  "viewerWrapper": "v-ZVZ",
  "hideFirstBlock": "kcPvi",
  "editor": "vcZRJ",
  "edit": "Q7Ws5",
  "view": "BF6lG",
  "editingToolbarWrapper": "Hy8rr",
  "selectAll": "r75RE",
  "disableSelection": "_5ljcW"
};
export {
  cell_default as default
};
//# sourceMappingURL=cell-scss.js.map
